import {DynamicColumnTable} from '@/components/organisms'
import {useQuery} from '@tanstack/react-query'
import axios from 'axios'

export const DisplayDynamicTable = () => {
  //  npx json-server  -p 3001 ./src/components/organisms/DynamicColumnTable/table-info.json
  const {
    data: rowData,
    isLoading: isDataLoading,
    isError: isDataError,
  } = useQuery({
    queryKey: ['rowData'],
    queryFn: async () => {
      const {data} = await axios.get('http://localhost:3001/data')
      return data
    },
  })

  const {
    data: colConfig,
    isLoading: isColLoading,
    isError: isColError,
  } = useQuery({
    queryKey: ['colConfig'],
    queryFn: async () => {
      const {data} = await axios.get('http://localhost:3001/config')
      return data
    },
  })

  if (isColError || isDataError) {
    return 'Error Loading the data from API'
  }

  if (isColLoading || isDataLoading) {
    return 'Loading Table Data '
  }
  
  return (
    <DynamicColumnTable
      pklass="dynamic-table"
      columns={colConfig || []}
      records={rowData || []}
      isExpandable={false}
      tableDescription=""
      tableHeader=""
      pageIndex={0}
      pageSize={10}
      selection={'multiple'}
      isDark={true}
      isResizable={true}
      onUpdate={() => {}}
      toolbarActions={[
        {
          text: 'Download',
          variant: 'primary',
          onClick: () => {},
        },
      ]}
    />
  )
}
